function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = require("react");

var styled = require("styled-components").default;

var Icon = require("@patternplate/component-icon").Icon;

var Link = require("@patternplate/component-link").Link;

var remark = require("remark");

var emoji = require("remark-gemoji-to-emoji");

var processor = remark().use(emoji);
module.exports = NavigationLabel;

function NavigationLabel(props) {
  return React.createElement(StyledLabelContainer, {
    "data-toggle-name": props.name,
    "data-trigger-name": props.name,
    "data-toggle-enabled": props.enabled,
    visible: props.visible,
    highlight: props.highlight
  }, React.createElement(StyledLabel, {
    highlight: props.highlight,
    enabled: props.enabled,
    size: props.size
  }, React.createElement(StyledLabelLink, {
    highlight: props.highlight,
    title: "".concat(props.enabled ? 'Close' : 'Expand', " ").concat(props.children, " list"),
    query: _defineProperty({}, "".concat(props.name, "-enabled"), !props.enabled)
  }, React.createElement(StyledLabelIcon, {
    enabled: props.enabled
  }, React.createElement(Icon, {
    symbol: "arrow-right"
  })), processor.processSync(props.children).contents)));
}

var SIZES = {
  S: 0.9,
  M: 1
};
var StyledLabel = styled.div.withConfig({
  displayName: "navigation-label__StyledLabel"
})(["box-sizing:border-box;padding:10px 10px;display:flex;align-items:center;font-family:", ";font-size:", "px;color:", ";background-color:", ";border-style:solid;border-top-color:", ";border-bottom-color:", ";border-width:", "px 0;width:100%;"], function (props) {
  return props.theme.fonts.default;
}, function (_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;
  return SIZES[size] * theme.fonts.fontSize;
}, function (props) {
  return props.theme.colors.color;
}, function (_ref3) {
  var enabled = _ref3.enabled,
      theme = _ref3.theme;
  return enabled ? theme.colors.backgroundTertiary : theme.colors.background;
}, function (_ref4) {
  var enabled = _ref4.enabled,
      theme = _ref4.theme;
  return enabled ? theme.colors.backgroundSecondary : theme.colors.border;
}, function (props) {
  return props.enabled ? 'transparent' : props.theme.colors.border;
}, function (props) {
  return props.highlight ? 1 : 0;
});
var StyledLabelIcon = styled.span.withConfig({
  displayName: "navigation-label__StyledLabelIcon"
})(["margin-right:10px;transform-origin:center;transform:rotate(", "deg);"], function (props) {
  return props.enabled ? 90 : 0;
});
var StyledLabelContainer = styled.div.withConfig({
  displayName: "navigation-label__StyledLabelContainer"
})(["display:", ";position:sticky;top:-1px;left:0;&[data-toggle-enabled=\"true\"]{", "{background-color:", ";border-top-color:", ";border-bottom-color:transparent;}", "{transform:rotate(90deg);}}&[data-toggle-enabled=\"false\"]{", "{background-color:", ";border-top-color:", ";border-bottom-color:", ";}", "{transform:rotate(0);}}"], function (props) {
  return props.visible ? "block" : "none";
}, StyledLabel, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.backgroundTertiary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.backgroundSecondary;
}, StyledLabelIcon, StyledLabel, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.background;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.border;
}, function (props) {
  return props.theme.colors.border;
}, StyledLabelIcon);
var StyledLabelLink = styled(Link).withConfig({
  displayName: "navigation-label__StyledLabelLink"
})(["display:block;color:", ";cursor:pointer;text-decoration:none;width:100%;"], function (props) {
  return props.theme.colors.color;
});
//# sourceMappingURL=index.js.map